import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-4 text-center"
}
const _hoisted_2 = { class: "mt-3 text-sm leading-5 text-gray-500" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "mt-6" }

import {
  DialogTitle,
} from '@headlessui/vue';
import BaseModal from '@/components/modals/BaseModal.vue';
import ButtonComponent from '@/components/buttons/ButtonComponent.vue';
import { CheckCircleIcon } from '@heroicons/vue/24/outline'


export default /*#__PURE__*/_defineComponent({
  __name: 'GeneralModal',
  props: {
    show: {
        type: Boolean
    },
    title: {
        type: String,
    },
    content: {
        type: String,
    },
    actionText: {
        type: String,
    },
    cancelText: {
        type: String,
    },
    customClass: {
        type: String,
        default: 'py-14 px-10'
    },
    checkIcon: {
        type: Boolean,
        default: false
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    customClass: __props.customClass,
    show: __props.show
  }, {
    default: _withCtx(() => [
      (__props.checkIcon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(CheckCircleIcon), { class: "mx-auto w-9 h-9 text-primary-600" })
          ]))
        : _createCommentVNode("", true),
      _createVNode(_unref(DialogTitle), {
        as: "p",
        class: "text-xl font-bold text-neutral-900",
        tabindex: "0"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.title), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        (__props.content)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(__props.content), 1))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "content")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(ButtonComponent, {
          size: "large",
          btnWidth: "primary rounded-lg",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('confirm')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.actionText), 1)
          ]),
          _: 1
        }),
        (__props.cancelText)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
              class: "mt-5 text-gray-600 cursor-pointer"
            }, _toDisplayString(__props.cancelText), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }, 8, ["customClass", "show"]))
}
}

})